<template>
  <div>
    <div class="row">
      <div class="col-11 p-0 m-0">
        <form @submit.prevent="searchFeature">
          <input class="form-control mb-1" :placeholder="$t(`product.single.dashboard.feature.search_input_placeholder`)" v-model="searchedWord">
        </form>
      </div>
      <div class="p-0 col-1 m-0">
        <i class="d-inline mr-1 bi bi-arrow-clockwise" @click="refreshFeatures"></i>
      </div>
    </div>

    <div class="feature_box_selector text-right shadow p-2 rounded">
      <p class="w-100 feature_box_selector_item" v-for="feature in filteredFeatures" :key="feature.id" @click="selectFeature(feature)">
        {{ feature.name }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FeatureSearch",
  data() {
    return {
      searchedWord: "",
    };
  },
  computed: {
    ...mapGetters({
      product: "Product/getProduct",
      dashboardFeature: "Feature/getFilteredFeatures",
    }),
    filteredFeatures() {
      // Use a computed property to filter features based on criteria
      return this.dashboardFeature.filter((feature) => this.handleFilterFunction(feature));
    },
  },
  methods: {
    searchFeature() {
      if (this.searchedWord.trim() !== "") {
        const searchWord = { words: this.searchedWord };
        this.$store.dispatch("Feature/filteredFeatures", searchWord);
      }
    },
    async refreshFeatures() {
      await this.$store.dispatch("Feature/getFeatures");
    },
    selectFeature(feature) {
      this.$emit("selectedFeature", feature);
    },
    handleFilterFunction(featureItem) {
      // Your filter criteria logic here
      return true; // Replace with your criteria
    },
  },
  mounted() {
    this.$store.dispatch("Feature/getFeatures");
  },
};
</script>

<style scoped>
.feature_box_selector {
  height: 150px;
  width: 100%;
  overflow-x: auto;
}

.feature_box_selector_item {
  cursor: pointer;
}
</style>
